import React, { Component } from "react";
import {
  company,
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  GET,
  POST,
  PUT,
  DELETE,
  Select,
  alert,
  float,
  t,
  format_date,
  activeOptions,
  sortOptions,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ
import { can } from "../../utils/permission";
import { data } from "react-router";

export default class Stocks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: company?.id || "",
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_search: "",
      filter_category: "",
      filter_status: "",
      filter_location: "",

      count: 0,
      page: 1,
      page_size: 10,
      data: [],
      data_parts: [], // เก็บข้อมูล Part Master สำหรับแสดงชื่อสินค้า
      data_warehouses: [], // เก็บข้อมูล Warehouse สำหรับแสดงชื่อคลัง
      data_locations: [], // เก็บข้อมูล Location สำหรับแสดงชื่อคลัง
      data_categories: [], // เก็บข้อมูล Category สำหรับแสดงชื่อหมวดหมู่
      data_reasons: [], // เก็บข้อมูล Reason สำหรับแสดงชื่อเหตุผล

      // -----------------------------------
      // Modal States
      // -----------------------------------
      modal_create: false,
      modal_view: false,
      modal_update: false, // เพิ่ม State นี้
      modal_adjust: false, // เพิ่ม State นี้
      selected_stock: null, // สำหรับ Modal View
      uid: "",

      // -----------------------------------
      // Form States
      // -----------------------------------
      form_part_id: "", // เอาไว้ใส่ใน array part_list_id
      form_warehouse_id: "",
      form_location_id: "",
      form_balance_qty: 0,
      form_reserved_qty: 0,
      form_available_qty: 0,
      form_last_cost: 0,
      form_is_active: true,

      form_part_uid: "",
      form_part_code: "",
      form_desc: "",
      form_brand: "",
      form_model: "",
      form_category: "",
      form_unit: "",
      form_unit_cost: "",
      form_unit_price: "",
      form_min_stock: "",
      form_max_stock: "",
      form_reorder_pt: "",
      form_reorder_qty: "",
      form_lead_time: "",
      form_supplier: "",
      form_barcode: "",

      adjust_stock_id: "",
      adjust_part_uid: "",
      adjust_warehouse_id: "",
      adjust_type: "Add Stock (+)",
      adjust_qty: 1,
      adjust_reason: "",
      adjust_notes: "",

      stock_id: "",
      // -----------------------------------
      // Summary Stats
      // -----------------------------------
      summary: {
        total_items: 0,
        in_stock: 0,
        low_stock: 0,
        out_of_stock: 0,
      },
    };
  }

  async componentDidMount() {
    loading(false);
    this.GetSummary();
    this.GetReferenceData();
    this.Get(1);
  }

  // ข้อมูลอ้างอิงสำหรับ dropdown: โหลดครั้งเดียวตอนเข้าหน้า ไม่โหลดซ้ำทุกครั้งที่เปลี่ยนหน้า/ค้นหา
  GetReferenceData = async () => {
    let data_parts, data_warehouses, data_categories, data_reasons;

    let [result_parts, result_warehouses, result_categories, result_reasons] = await Promise.all([
      // lite=true: backend ส่งเฉพาะ field หลัก (รวม uom_cost) ไม่ join relation
      GET("warehouse/part-masters", { page_size: 10000, page: 0, lite: "true" }),
      GET("warehouse/warehouses", { page_size: 10000, page: 0 }),
      GET("warehouse/part-categories", { page_size: 10000, page: 0 }),
      GET("warehouse/reasons", { page_size: 10000, page: 0 }),
    ]);

    if (result_parts?.status) {
      data_parts =
        result_parts?.data?.map((item) => ({
          ...item,
          label: `${item.part_number} ${item.name}`,
          value: item.uid,
        })) || [];
    }
    if (result_warehouses?.status) {
      data_warehouses =
        result_warehouses?.data?.map((item) => ({
          ...item,
          label: item.name,
          value: item.uid,
        })) || [];
    }
    if (result_categories?.status) {
      data_categories =
        result_categories?.data?.map((e) => ({
          is_active: e.is_active,
          value: e.uid,
          label: e.name,
        })) || [];
    }
    if (result_reasons?.status) {
      data_reasons =
        result_reasons?.data?.map((e) => ({ is_active: e.is_active, value: e.uid, label: e.name })) ||
        [];
    }

    this.setState({
      data_parts: data_parts,
      data_warehouses: data_warehouses,
      data_categories: data_categories,
      data_reasons: data_reasons,
    });
  };

  GetSummary = async () => {
    let result = await GET("warehouse/stocks/summary");
    if (result?.status) {
      // ตัวแปรที่ได้จาก API อาจจะต่างกัน ให้ปรับ mapping ให้ตรงกับ Response ของ backend
      this.setState({
        summary: {
          total_items: result.data?.total_item || 0,
          in_stock: result.data?.balance || 0,
          low_stock: result.data?.low_stock || 0,
          out_of_stock: result.data?.out_of_stock || 0,
        },
      });
    }
  };

  Get = async (page) => {
    const {
      filter_search,
      page_size,
      filter_category,
      filter_status,
      filter_location,
    } = this.state;
    loading(true);

    let result = await GET("warehouse/stocks", {
      page_size: page_size,
      page: page,
      data_search: filter_search || "",
      category_id: filter_category || "",
      status: filter_status,
      warehouse_id: filter_location || "",
    });

    if (result?.status) {
      this.setState({
        data: result.data || [],
        count: result.pagination?.count || 0,
      });
    }

    loading(false);
  };

  GetPartByID = async (item) => {
    loading(true);

    let result = await GET("warehouse/part-masters", { uid: item?.part?.uid });
    if (result?.status) {
      const stockId = item?.uid || "";
      const warehouseLocations =
        item?.warehouse?.locations?.map((location) => ({
          value: location.uid,
          label: location.name,
        })) ||
        this.state.data_warehouses?.find(
          (warehouse) => warehouse.value === item?.warehouse?.uid,
        )?.locations?.map((location) => ({
          value: location.uid,
          label: location.name,
        })) ||
        [];

      let data = result.data;
      this.setState({
        form_part_uid: data.uid,
        form_part_code: data.part_number || "",
        form_desc: data.name || data.description || "",
        form_brand: data.brand?.uid || "",
        form_model: data.model?.uid || "",
        form_category: data.part_category?.uid || "",
        form_unit: data.uom?.uid || "",
        form_unit_cost: data.uom_cost?.toString() || "0",
        form_unit_price: data.selling_price?.toString() || "0",
        form_min_stock: data.min_stock?.toString() || "0",
        form_max_stock: data.max_stock?.toString() || "0",
        form_reorder_pt: data.reorder_point?.toString() || "0",
        form_reorder_qty: data.reorder_qty?.toString() || "0",
        form_lead_time: data.lead_time_days?.toString() || "0",
        form_supplier: data.supplier?.uid || "",
        form_barcode: data.barcode || "",
        form_is_active: data.is_active !== undefined ? data.is_active : true,
        form_warehouse_id: item?.warehouse?.uid || "",
        form_location_id: item?.location?.uid || "",
        data_locations: warehouseLocations,
        stock_id: stockId,
      });
      loading(false);
    }
  };

  GetByID = async (item) => {
    loading(true);

    let result = await GET("warehouse/stocks", { uid: item?.uid });
    if (result?.status) {
      this.setState({
        selected_stock: result?.data,
        adjust_stock_id: item.uid || "",
        adjust_part_uid: item.part?.uid || "",
        adjust_warehouse_id: item.warehouse?.uid || "",
        adjust_type: "add",
        adjust_qty: 1,
        adjust_reason: "",
        adjust_notes: "",
      });
      loading(false);
    }
  };

  Create = async () => {
    const {
      company_id,
      uid,
      form_part_id,
      form_warehouse_id,
      form_location_id,
      form_balance_qty,
      form_reserved_qty,
      form_available_qty,
      form_last_cost,
      form_is_active,
    } = this.state;

    // Validation
    if (!form_part_id.trim()) {
      alert("", "warning", t("warning"), t("please_specify_part"));
      return;
    }
    if (!form_warehouse_id.trim()) {
      alert("", "warning", t("warning"), t("please_specify_warehouse"));
      return;
    }
    if (!form_location_id.trim()) {
      alert("", "warning", t("warning"), t("please_specify_location"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);

      // Payload สำหรับ Initialize (POST)
      let body = {
        company_id: company_id,
        part_list_id: [form_part_id], // อ้างอิงตาม cURL ที่ให้มา
        warehouse_id: form_warehouse_id,
        location_id: form_location_id,
        balance_qty: Number(form_balance_qty) || 0,
        reserved_qty: Number(form_reserved_qty) || 0,
        available_qty: Number(form_available_qty) || 0,
        last_checkstock_date: "",
        last_checkstock_qty: 0,
        last_cost: Number(form_last_cost) || 0,
        is_active: form_is_active,
      };

      // Payload สำหรับ Update (PUT)
      // *หมายเหตุ: ถ้า API อัปเดตโครงสร้างต่างออกไป สามารถแยก Object Body ได้
      let putBody = {
        company_id: company_id,
        part_id: form_part_id,
        warehouse_id: form_warehouse_id,
        location_id: form_location_id,
        balance_qty: Number(form_balance_qty) || 0,
        reserved_qty: Number(form_reserved_qty) || 0,
        available_qty: Number(form_available_qty) || 0,
        last_cost: Number(form_last_cost) || 0,
        is_active: form_is_active,
      };

      let result = !uid
        ? await POST("warehouse/stocks/initialize", body)
        : await PUT("warehouse/stocks/" + uid, putBody);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false });
        this.resetForm();
        this.GetSummary();
        this.Get(1);
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  Update = async (item) => {
    const {
      company_id,
      form_part_uid,
      form_part_code,
      form_desc,
      form_brand,
      form_model,
      form_category,
      form_unit,
      form_unit_cost,
      form_unit_price,
      form_min_stock,
      form_max_stock,
      form_reorder_pt,
      form_reorder_qty,
      form_lead_time,
      form_supplier,
      form_barcode,
      stock_id,
      form_warehouse_id,
      form_location_id,
      form_is_active,
    } = this.state;

    // Validation
    if (!form_part_uid.trim()) {
        alert("", "warning", t("warning"), t("please_specify_part"));
        return;
    }
    if (!form_warehouse_id.trim()) {
      alert("", "warning", t("warning"), t("please_specify_warehouse"));
      return;
    }
    if (!form_location_id.trim()) {
      alert("", "warning", t("warning"), t("please_specify_location"));
      return;
    }

    loading(true);
    let body = {
        company_id: company_id,
        part_number: form_part_code,
        name: form_desc,
        description: form_desc,
        brand_id: form_brand,
        model_id: form_model,
        part_category_id: form_category,
        uom_id: form_unit,
        uom_cost: Number(form_unit_cost) || 0,
        selling_price: Number(form_unit_price) || 0,
        min_stock: Number(form_min_stock) || 0,
        max_stock: Number(form_max_stock) || 0,
        reorder_point: Number(form_reorder_pt) || 0,
        reorder_qty: Number(form_reorder_qty) || 0,
        lead_time_days: Number(form_lead_time) || 0,
        supplier_id: form_supplier,
        barcode: form_barcode,
        picture: "",

        stock_id: stock_id,
        warehouse_id: form_warehouse_id,
        location_id: form_location_id,

        is_active: form_is_active,
    };

    let result = await PUT("warehouse/part-masters/" + form_part_uid, body);

    if (result?.status === true) {
      alert("", "success");
      this.setState({ modal_update: false });
      this.GetSummary();
      this.Get(1);
    } else {
      alert(
        "",
        "warning",
        t("warning"),
        result?.message || t("error_occurred"),
      );
    }
    loading(false);
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/stocks/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.GetSummary();
        this.Get(1);
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  AdjestStock = async () => {
    loading(true);
    const {
      company_id,
      adjust_stock_id,
      adjust_part_uid,
      adjust_warehouse_id,
      adjust_type,
      adjust_qty,
      adjust_reason,
      adjust_notes,
    } = this.state;
    let body = {
      company_id: company_id,
      stock_id: adjust_stock_id,
      part_id: adjust_part_uid,
      from_warehouse_id: adjust_warehouse_id,
      quantity: Number(adjust_type === "add" ? adjust_qty : -adjust_qty),
      reason_id: adjust_reason,
      notes: adjust_notes,
      status: "pending",
    };

    let result = await POST("warehouse/stock-movements/adjustment", body);

    if (result?.status === true) {
      alert("#", "success");
      this.setState({ modal_adjust: false });
    } else {
      alert(
        "",
        "warning",
        t("warning"),
        result?.message || t("error_occurred"),
      );
    }
    loading(false);
  };

  resetForm = () => {
    this.setState({
      uid: "",
      form_part_id: "",
      form_warehouse_id: "",
      form_location_id: "",
      form_balance_qty: 0,
      form_reserved_qty: 0,
      form_available_qty: 0,
      form_last_cost: 0,
      form_is_active: true,
    });
  };

  formatNumber = (num) => {
    return num?.toLocaleString() || "0";
  };

  // Helper หาค่าสีของ Status / จำนวนคงเหลือ
  getAvailableColor = (qty,min) => {
    if (qty <= 0) return "danger";
    if (qty <= min) return "warning";
    return "dark";
  };

  getStatusBadge = (qty,min) => {
    if (qty <= 0) return { label: t("out_of_stock"), color: "danger" };
    if (qty <= min) return { label: t("low_stock_alert"), color: "warning" };
    return { label: t("in_stock"), color: "success" };
  };

  render() {
    const {
      data,
      count,
      summary,
      data_reasons,
      filter_search,
      filter_category,
      filter_status,
      filter_location,
      modal_create,
      modal_update,
      modal_adjust,
      modal_view,
      selected_stock,
      form_part_id,
      form_warehouse_id,
      form_location_id,
      form_balance_qty,
      form_reserved_qty,
      form_available_qty,
      form_last_cost,
      data_parts,
      data_warehouses,
      data_locations,
      data_categories,

      uid,
      form_part_uid,
      form_part_code,
      form_desc,
      form_brand,
      form_model,
      form_category,
      form_unit,
      form_unit_cost,
      form_unit_price,
      form_min_stock,
      form_max_stock,
      form_reorder_pt,
      form_reorder_qty,
      form_lead_time,
      form_supplier,
      form_barcode,
      form_is_active,

      adjust_type,
      adjust_qty,
      adjust_reason,
      adjust_notes,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="mb-4">
                    <h3 className="fw-bold mb-1 text-dark">{t("main_warehouse")}</h3>
                    <div className="text-secondary text-14">{t("manage_inventory")}</div>
                </div>

                {/* Top Stats Cards (4 Columns) */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf494"}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.total_items)}</h3>
                                    <div className="text-secondary text-12">{t("total_items")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf058"}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.in_stock)}</h3>
                                    <div className="text-secondary text-12">{t("in_stock")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf071"}</div>
                                <div>
                                    <h3 className="fw-bold text-warning mb-0">{this.formatNumber(summary.low_stock)}</h3>
                                    <div className="text-secondary text-12">{t("low_stock_alert")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">{"\uf057"}</div>
                                <div>
                                    <h3 className="fw-bold text-danger mb-0">{this.formatNumber(summary.out_of_stock)}</h3>
                                    <div className="text-secondary text-12">{t("out_of_stock")}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap align-items-center gap-3">
                        <div className="d-flex gap-3 flex-wrap flex-grow-1">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    placeholder={t("search_placeholder")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>
                            {/* สามารถปรับปรุง dropdown data ตาม API ที่มีได้ */}
                            <Select
                                className="form-control wpx-180"
                                options={data_categories}
                                value={filter_category}
                                onChange={(e) => {
                                    this.setState({ filter_category: e });
                                }}
                                placeholder={t("select_type")}
                            />
                            <Select
                                className="form-control wpx-180"
                                options={data_warehouses}
                                value={filter_location}
                                onChange={(e) => {
                                    this.setState({ filter_location: e });
                                }}
                                placeholder={t("select_warehouse")}
                            />
                            <Select sort={false}
                                className="form-control wpx-150"
                                options={[
                                    // { value: "", label: t("all_statuses") },
                                    { value: "InStock", label: t("in_stock") },
                                    { value: "LowStock", label: t("low_stock_alert") },
                                    { value: "OutOfStock", label: t("out_of_stock") },
                                ]}
                                value={filter_status}
                                onChange={(e) => {
                                    this.setState({ filter_status: e });
                                }}
                                placeholder={t("all_statuses")}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() =>
                                        this.setState(
                                            {
                                                filter_search: "",
                                                filter_status: "",
                                                filter_category: "",
                                                filter_location: "",
                                            },
                                            () => this.Get(1)
                                        )
                                    }
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        <div className="d-flex gap-2">
                            {/* <button className="btn btn-white bg-white border border-light px-3 py-2 fw-bold rounded-3 shadow-sm text-dark d-flex align-items-center">
                                <span className="icon me-2 text-14">{"\uf019"}</span> {t("export")}
                            </button> */}
                            {can("stock.create") && (
                            <button
                                className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                                style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                                onClick={() => {
                                    this.resetForm();
                                    this.setState({ modal_create: true });
                                }}
                            >
                                <span className="me-2 text-16">+</span> {t("add_item")}
                            </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm pb-2">
                    {/* Stock Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 border-0 wpx-150">{t("part_code")}</th>
                                    <th className="py-3 border-0 wpx-250">{t("description")}</th>
                                    <th className="py-3 border-0 wpx-150">{t("set_type")} 1</th>
                                    <th className="py-3 border-0 wpx-150">{t("warehouse")}</th>
                                    <th className="py-3 border-0 wpx-150">{t("storage_area")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("on_hand")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("reserved")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("available")}</th>
                                    <th className="py-3 border-0 text-center wpx-150">{t("status")}</th>
                                    <th className="py-3 border-0 text-end wpx-120">{t("unit_cost")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("manage")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.length > 0 ? (
                                    data?.map((item, idx) => {
                                        // คำนวณค่าต่างๆ เผื่อว่า API ส่งมาไม่ครบ
                                        const availableQty = item.available_qty || 0;
                                        const minQty = item.part?.min_stock || 0;
                                        const availableColor = this.getAvailableColor(availableQty, minQty);
                                        const statusObj = this.getStatusBadge(availableQty, minQty);

                                        // สมมติว่า Part Code อยู่ใน object ที่ซ้อนกัน หรือมาตรงๆ
                                        const partCode = item.part?.part_number || "-";
                                        const partName = item.part?.name || "-";
                                        const category = item.part?.part_category?.name || "-";
                                        const warehouse = item.warehouse?.name || "-";
                                        const location = item.location?.name || "-";

                                        return (
                                            <tr key={idx} className="border-bottom border-light bg-white">
                                                <td className="text-nowrap">
                                                    <span className="fw-bold text-primary text-14 pointer hover-underline">{partCode}</span>
                                                </td>

                                                <td className="text-nowrap">
                                                    <div className="text-dark text-14">{partName}</div>
                                                </td>

                                                <td className="text-nowrap">
                                                    <div className="text-secondary text-14">{category}</div>
                                                </td>

                                                <td className="text-nowrap">
                                                    <div className="text-secondary text-14">{warehouse}</div>
                                                </td>

                                                <td className="text-nowrap">
                                                    <div className="text-secondary text-14">{location}</div>
                                                </td>

                                                <td className="text-center">
                                                    <span className="fw-bold text-dark text-14">{item.balance_qty || 0}</span>
                                                </td>

                                                <td className="text-center">
                                                    <span className="text-secondary text-14">{item.reserved_qty || 0}</span>
                                                </td>

                                                <td className="text-center">
                                                    <span className={`fw-bold text-${availableColor} text-14`}>{availableQty}</span>
                                                </td>

                                                <td className="text-center">
                                                    <span
                                                        className={`badge bg-${statusObj.color}-light text-${statusObj.color} rounded-pill px-3 py-1 fw-bold text-10 border border-${statusObj.color}`}
                                                    >
                                                        {statusObj.label}
                                                    </span>
                                                </td>

                                                <td className="text-end">
                                                    <div className="fw-bold text-dark text-14">{this.formatNumber(item.last_cost || 0)}</div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="d-flex align-items-center gap-2 justify-content-center">
                                                        <ActionIconButton
                                                            label={t("view")}
                                                            icon={ACTION_ICONS.view}
                                                            variant="primary"
                                                            onClick={async () => {
                                                                await this.GetByID(item);
                                                                this.setState({ modal_view: true });
                                                            }}
                                                        />
                                                        {can("part-master.update") && (
                                                        <ActionIconButton
                                                            label={t("edit")}
                                                            icon={ACTION_ICONS.edit}
                                                            variant="warning"
                                                            onClick={async () => {
                                                                await this.GetPartByID(item);
                                                                this.setState({ modal_update: true });
                                                            }}
                                                        />
                                                        )}
                                                        {can("stock-adjustment.create") && (
                                                        <ActionIconButton
                                                            label={t("adjust")}
                                                            icon={"\uf1de"}
                                                            variant="primary"
                                                            onClick={async () => {
                                                                await this.GetByID(item);
                                                                this.setState({ modal_adjust: true });
                                                            }}
                                                        />
                                                        )}
                                                        {/* <span className="icon text-danger pointer hover-danger transition-hover" onClick={() => this.Delete(item.uid)}>{"\uf2ed"}</span> */}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="11" className="text-center py-4 text-secondary">
                                            {t("no_data_found")}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center p-4 border-top border-light flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} 1-{data?.length} {t("of")} {this.formatNumber(count)} {t("items_unit")}
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                    </div>
                </div>
            </div>

            {/* MODAL: สร้าง / แก้ไขสต็อก */}
            <Modal size="lg" show={modal_create} onHide={() => this.setState({ modal_create: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">{uid ? t("edit_stock_title") : t("create_stock_title")}</h4>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <h6 className="fw-bold text-primary mb-3">{t("product_and_warehouse_info")}</h6>
                    <div className="row g-4 mb-4">
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("part")} <span className="text-danger">{t("required_field")}</span>
                            </label>
                            <Select
                                className="form-control w-100"
                                options={activeOptions(data_parts, form_part_id)}
                                value={form_part_id}
                                onChange={(e, i) =>
                                    this.setState({
                                        form_part_id: e,
                                        form_last_cost: i.uom_cost,
                                    })
                                }
                                placeholder={t("select_part")}
                                isDisabled={!!uid} // ล็อกไว้ถ้าแก้ไข (แล้วแต่ Flow ธุรกิจ)
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("warehouse")} <span className="text-danger">{t("required_field")}</span>
                            </label>
                            <Select
                                className="form-control w-100"
                                options={activeOptions(data_warehouses, form_warehouse_id)}
                                value={form_warehouse_id}
                                onChange={(e, i) => this.setState({ form_warehouse_id: e, form_location_id: "", data_locations: i.locations?.map((l) => ({ is_active: l.is_active, value: l.uid, label: l.name })) })}
                                placeholder={t("select_warehouse")}
                                isDisabled={!!uid} // ล็อกไว้ถ้าแก้ไข (แล้วแต่ Flow ธุรกิจ)
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("storage_area")} <span className="text-danger">{t("required_field")}</span>
                            </label>
                            <Select
                                className="form-control w-100"
                                options={activeOptions(data_locations, form_location_id)}
                                value={form_location_id}
                                onChange={(e) => this.setState({ form_location_id: e })}
                                placeholder={t("select_location")}
                                isDisabled={!!uid} // ล็อกไว้ถ้าแก้ไข (แล้วแต่ Flow ธุรกิจ)
                            />
                        </div>
                    </div>

                    <h6 className="fw-bold text-primary mb-3">{t("quantity_and_cost_info")}</h6>
                    <div className="row g-4">
                        {modal_create && (
                            <div className="col-md-6">
                                <label className="form-label text-14 text-dark fw-bold mb-2">{t("balance_qty_label")}</label>
                                <input
                                    type="number"
                                    className="form-control py-2 shadow-none"
                                    placeholder="0"
                                    value={form_balance_qty}
                                    onChange={(e) => this.setState({ form_balance_qty: e.target.value })}
                                />
                            </div>
                        )}
                        {modal_create && (
                            <div className="col-md-6">
                                <label className="form-label text-14 text-dark fw-bold mb-2">{t("reserved_qty_label")}</label>
                                <input
                                    type="number"
                                    className="form-control py-2 shadow-none"
                                    placeholder="0"
                                    value={form_reserved_qty}
                                    onChange={(e) => this.setState({ form_reserved_qty: e.target.value })}
                                />
                            </div>
                        )}
                        {modal_create && (
                            <div className="col-md-6">
                                <label className="form-label text-14 text-dark fw-bold mb-2">{t("available_qty_label")}</label>
                                <input
                                    type="number"
                                    className="form-control py-2 shadow-none"
                                    placeholder="0"
                                    value={form_available_qty}
                                    onChange={(e) => this.setState({ form_available_qty: e.target.value })}
                                />
                            </div>
                        )}
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("last_cost_label")}</label>
                            <input
                                type="number"
                                className="form-control py-2 shadow-none"
                                placeholder="0.00"
                                value={form_last_cost}
                                onChange={(e) => this.setState({ form_last_cost: e.target.value })}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top border-light pt-3 px-4 pb-4 d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold bg-white" onClick={() => this.setState({ modal_create: false })}>
                        {t("cancel")}
                    </button>
                    {can("stock.create") && (
                    <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold text-white shadow-sm" style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }} onClick={this.Create}>
                        {t("save")}
                    </button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* 1. MODAL: ดูรายละเอียดสต็อก (Detail View) */}
            <Modal size="lg" show={modal_view} onHide={() => this.setState({ modal_view: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">{t("stock_item_details")}</h4>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    {selected_stock && (
                        <>
                            {/* ข้อมูลพื้นฐาน */}
                            <div className="row g-4 mb-4">
                                <div className="col-md-6">
                                    <div className="text-secondary text-12 fw-bold mb-1">{t("part_code")}</div>
                                    <div className="text-dark fw-bold text-16">{selected_stock.part?.part_number || "-"}</div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-secondary text-12 fw-bold mb-1">{t("description")}</div>
                                    <div className="text-dark fw-bold text-16">{selected_stock.part?.name || "-"}</div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-secondary text-12 fw-bold mb-1">{t("category")}</div>
                                    <div className="text-dark fw-bold text-16">{selected_stock.part?.part_category?.name || "-"}</div>
                                </div>
                                <div className="col-md-6">
                                    <div className="text-secondary text-12 fw-bold mb-1">{t("unit")}</div>
                                    <div className="text-dark fw-bold text-16">{selected_stock.part?.uom?.name || "-"}</div>
                                </div>
                            </div>

                            {/* Stock Information Box */}
                            <div className="bg-light rounded-4 p-4 mb-4">
                                <h6 className="fw-bold text-dark mb-3">{t("stock_information")}</h6>
                                <div className="row text-center">
                                    <div className="col-3">
                                        <h2 className="fw-bold text-dark mb-1">{this.formatNumber(selected_stock.balance_qty || 0)}</h2>
                                        <div className="text-secondary text-12 fw-bold">{t("on_hand")}</div>
                                    </div>
                                    <div className="col-3">
                                        <h2 className="fw-bold text-dark mb-1">{this.formatNumber(selected_stock.reserved_qty || 0)}</h2>
                                        <div className="text-secondary text-12 fw-bold">{t("reserved")}</div>
                                    </div>
                                    <div className="col-3">
                                        <h2 className="fw-bold text-danger mb-1">{this.formatNumber(selected_stock.available_qty || 0)}</h2>
                                        <div className="text-secondary text-12 fw-bold">{t("available_label")}</div>
                                    </div>
                                    <div className="col-3">
                                        <h2 className="fw-bold text-warning mb-1">{this.formatNumber(selected_stock.part?.reorder_point || 0)}</h2>
                                        <div className="text-secondary text-12 fw-bold">{t("reorder_point")}</div>
                                    </div>
                                </div>
                            </div>

                            {/* Recent Transactions */}
                            <div>
                                <h6 className="fw-bold text-dark mb-3">{t("recent_transactions")}</h6>
                                <div className="table-responsive">
                                    <table className="table table-borderless align-middle">
                                        <thead className="border-bottom border-light">
                                            <tr className="text-dark fw-bold text-14">
                                                <th className="py-2">{t("date")}</th>
                                                <th className="py-2">{t("type")}</th>
                                                <th className="py-2">{t("reference")}</th>
                                                <th className="py-2 text-center">{t("quantity")}</th>
                                                <th className="py-2 text-center">{t("on_hand")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* ข้อมูลจำลองตามแบบ หากมี API Transaction ให้ map จากตรงนี้ */}
                                            {selected_stock?.history?.map((item, index) => (
                                                <tr className="border-bottom border-light">
                                                    <td className="py-3 text-14">{item.movement_date ? format_date(item.movement_date, "dd/mm/yyyy", "th") : "-"}</td>
                                                    <td className={`py-3 ${item.quantity > 0 ? "text-success" : "text-danger"} text-14`}>
                                                        {item.movement_type === "adjustment" ? (item.quantity > 0 ? t("stock_increased") : t("stock_decreased")) : item.movement_type}
                                                    </td>
                                                    <td className="py-3 text-dark text-14">{item.movement_code}</td>
                                                    <td className={`py-3 ${item.quantity > 0 ? "text-success" : "text-danger"} text-center fw-bold text-14`}>{item.quantity}</td>
                                                    <td className="py-3 text-dark text-center text-14">{Number(item.balance_qty)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={modal_update} onHide={() => this.setState({ modal_update: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">{form_part_uid ? t("edit_part_title") : t("add_new_part_title")}</h4>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <div className="row g-4">
                        <div className="col-md-12">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("part_code")} <span className="text-danger">{t("required_field")}</span>
                            </label>
                            <input
                                type="text"
                                className="form-control py-2 rounded-3 text-secondary"
                                placeholder="PRT-XXXXXX"
                                value={form_part_code}
                                onChange={(e) => this.setState({ form_part_code: e.target.value })}
                                disabled
                            />
                        </div>

                        <div className="col-12">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("description")} <span className="text-danger">{t("required_field")}</span>
                            </label>
                            <input
                                type="text"
                                className="form-control py-2 rounded-3 text-secondary"
                                placeholder={t("description")}
                                value={form_desc}
                                onChange={(e) => this.setState({ form_desc: e.target.value })}
                            />
                        </div>

                        {/* ประเภท (CATEGORY) - เป็นรูปแบบปุ่มตามรูป */}
                        <div className="col-6">
                            <label className="form-label text-14 text-secondary fw-bold mb-2">
                                {t("category")} <span className="text-danger">{t("required_field")}</span>
                            </label>
                            <div className="d-flex gap-3 flex-wrap">
                                <select className="form-select py-2 rounded-3 text-secondary" value={form_category} onChange={(e) => this.setState({ form_category: e.target.value })}>
                                    <option value="">{t("select_category")}</option>
                                    {sortOptions(activeOptions(data_categories, form_category)).map((cat) => {
                                        return (
                                            <option key={cat.value} value={cat.value}>
                                                {cat.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("unit_cost")}</label>
                            <input
                                type="number"
                                className="form-control py-2 rounded-3 text-secondary"
                                placeholder="0.00"
                                value={form_unit_cost}
                                onChange={(e) => this.setState({ form_unit_cost: e.target.value })}
                                onFocus={() => {
                                    if (form_unit_cost == 0) {
                                        this.setState({ form_unit_cost: "" });
                                    }
                                }}
                                onBlur={() => {
                                    if (form_unit_cost === "") {
                                        this.setState({ form_unit_cost: 0 });
                                    }
                                }}
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("warehouse")} <span className="text-danger">{t("required_field")}</span>
                            </label>
                            <Select
                                className="form-control w-100"
                                options={activeOptions(data_warehouses, form_warehouse_id)}
                                value={form_warehouse_id}
                                onChange={(e, i) =>
                                    this.setState({
                                        form_warehouse_id: e,
                                        form_location_id: "",
                                        data_locations:
                                            i?.locations?.map((location) => ({
                                                value: location.uid,
                                                label: location.name,
                                            })) || [],
                                    })
                                }
                                placeholder={t("select_warehouse")}
                                isDisabled={!!uid} // ล็อกไว้ถ้าแก้ไข (แล้วแต่ Flow ธุรกิจ)
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("storage_area")} <span className="text-danger">{t("required_field")}</span>
                            </label>
                            <Select
                                className="form-control w-100"
                                options={activeOptions(data_locations, form_location_id)}
                                value={form_location_id}
                                onChange={(e) => this.setState({ form_location_id: e })}
                                placeholder={t("select_location")}
                                isDisabled={!!uid} // ล็อกไว้ถ้าแก้ไข (แล้วแต่ Flow ธุรกิจ)
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top border-light pt-3 px-4 pb-4 d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_update: false })}>
                        {t("cancel")}
                    </button>
                    {can("part-master.update") && (
                    <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold shadow-sm" style={{ backgroundColor: "#3b82f6", borderColor: "#3b82f6" }} onClick={this.Update}>
                        {t("save")}
                    </button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* 3. MODAL: Adjust Stock */}
            <Modal size="md" show={modal_adjust} onHide={() => this.setState({ modal_adjust: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">{t("adjust_stock")}: {selected_stock?.part?.part_code || selected_stock?.part_code || "PRT-001234"}</h4>
                </Modal.Header>
                <Modal.Body className="bg-white">
                    <div className="bg-light rounded-3 p-3 mb-4">
                        <div className="text-secondary text-14 mb-1">
                            {t("current_stock")}: <span className="text-dark fw-bold">{selected_stock?.balance_qty} EA</span>
                        </div>
                        <div className="text-secondary text-14">
                            {t("available_label")}: <span className="text-danger fw-bold">{selected_stock?.available_qty} EA</span>
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="form-label text-14 text-secondary fw-bold mb-1">{t("adjustment_type")}</label>
                        <select className="form-select shadow-none" value={adjust_type} onChange={(e) => this.setState({ adjust_type: e.target.value })}>
                            <option value="add">{t("add_stock_option")}</option>
                            <option value="deduct">{t("deduct_stock_option")}</option>
                        </select>
                    </div>

                    <div className="mb-3">
                        <label className="form-label text-14 text-secondary fw-bold mb-1">{t("quantity")}</label>
                        <div className="position-relative">
                            <input
                                type="text"
                                className={`form-control shadow-none ps-4 ${adjust_type === "add" ? "bg-success-light text-success" : "bg-danger-light text-danger"}`}
                                value={adjust_qty}
                                onChange={(e) => {
                                    if (!float(e.target.value)) return;
                                    this.setState({ adjust_qty: e.target.value });
                                }}
                            />
                            <span className={`position-absolute ${adjust_type === "add" ? "text-success" : "text-danger"}`} style={{ left: 10, top: 5 }}>
                                {adjust_type === "add" ? "+" : "-"}
                            </span>
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="form-label text-14 text-secondary fw-bold mb-1">{t("reason")}</label>
                        <select className="form-select shadow-none" value={adjust_reason} onChange={(e) => this.setState({ adjust_reason: e.target.value })}>
                            <option value="">{t("select_reason")}</option>
                            {sortOptions(activeOptions(data_reasons, adjust_reason)).map((reason) => {
                                return (
                                    <option key={reason.value} value={reason.value}>
                                        {reason.label}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    <div className="mb-4">
                        <label className="form-label text-14 text-secondary fw-bold mb-1">{t("note")}</label>
                        <textarea
                            className="form-control shadow-none"
                            rows="3"
                            placeholder={t("additional_notes")}
                            value={adjust_notes}
                            onChange={(e) => this.setState({ adjust_notes: e.target.value })}
                        ></textarea>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top border-light d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold bg-white" onClick={() => this.setState({ modal_adjust: false })}>
                        {t("cancel")}
                    </button>
                    {can("stock-adjustment.create") && (
                    <button
                        className="btn btn-primary px-4 py-2 rounded-3 fw-bold text-white shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={() => this.AdjestStock()}
                    >
                        {t("save")}
                    </button>
                    )}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
